import React from 'react';
import '../QuestionnaireForm.css';
import { useLanguage } from '../LanguageContext';
import { getTranslation } from '../consts/translations';

const PreviewExpiredPage: React.FC = () => {
  const { language } = useLanguage();
  const translation = getTranslation(language);

  return (
    <div className='finished-form-page'>
      <div>{translation.preview_expired_message}</div>
    </div>
  );
};

export default PreviewExpiredPage;
